module.exports = __webpack_public_path__ + "media/images/result_sets/circles/8n9r2n5n-c8d13f29cf403d88fca4562070cc6540.svg";